export default __webpack_public_path__ + "static/media/ret-res9.45637ce6.jpg";